/* eslint-disable @next/next/no-img-element */
// @ts-nocheck

import { background_list } from '@/assets/images'
import { StyledButton } from '@/components/atoms'
import Image from 'next/image'
import {
	Accordion,
	AccordionItem,
	AccordionItemButton,
	AccordionItemHeading,
	AccordionItemPanel,
	AccordionItemState,
} from 'react-accessible-accordion'
import { useTranslation } from 'react-i18next'
import { BiChevronDown } from 'react-icons/bi'

const items = [
	{
		uuid: '1',
		heading: 'ATM BCA',
		data: [
			'Select Other Transaction on the main menu & Select Transfer',
			'Select to BCA Virtual Account',
			'Insert BCA Virtual Account Number',
			'Insert the payable ammount, And confirm the payment',
			'Payment Complete',
		],
	},
  {
		uuid: '2',
		heading: 'Klik BCA',
		data: [
			'Select Other Transaction on the main menu & Select Transfer',
			'Select to BCA Virtual Account',
			'Insert BCA Virtual Account Number',
			'Insert the payable ammount, And confirm the payment',
			'Payment Complete',
		],
	},
]

const PendingPaymentStatus = () => {
	const { t } = useTranslation('product')

  return (
    <div className='tw-w-full'>
      <div className='tw-p-5 tw-bg-white tw-border tw-border-light-green tw-rounded-md tw-mb-5 tw-flex tw-flex-col tw-items-center'>
        <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-3xl tw-text-xl tw-mb-5 tw-text-center'>
          {t('product.pending_payment')}
        </h1>
        <Image src={background_list.pending_payment} alt='' width={100} height={100} />
        <h2 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-lg tw-font-semibold tw-mt-4'>
         {t('product.payment_detail')}
        </h2>
        <div className='tw-flex tw-justify-between tw-flex-row tw-gap-5 tw-font-semibold tw-mt-6 tw-mb-4'>
          <img
            src='https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Bank_Central_Asia.svg/2560px-Bank_Central_Asia.svg.png'
            alt=''
            className='tw-h-5'
          />
          <span>Bank Central Asia</span>
        </div>
        <div className='tw-font-semibold tw-flex tw-flex-col tw-items-center tw-text-center'>
          <span className='tw-my-1 md:tw-text-[15px] tw-text-sm'>
           {t('product.va_number')}
          </span>
          <span className='tw-mb-7 tw-text-dark-green'>14179092063</span>
          <span className='tw-mb-3 md:tw-text-[15px] tw-text-sm'>{t('product.transaction_id')}</span>
          <span className='tw-mb-3 tw-text-dark-green md:tw-text-xl tw-text-sm'>
            SB-BCA-1234567890
          </span>
          <span className='tw-mb-3 md:tw-text-[15px] tw-text-sm'>
            {t('product.complete_payment')}
          </span>
          <span className='tw-mb-3 tw-text-dark-green'>01:23:59:45</span>
        </div>

        <div className='tw-bg-white tw-p-4 tw-w-full tw-mb-5 md:tw-max-w-md tw-max-w-full'>
          <div className='tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-3 md:tw-text-[15px] tw-text-xs'>
            <div className='tw-flex tw-justify-between'>
              <span>{t('product.complete_payment1')}</span>
              <span className='tw-text-dark-green tw-font-semibold'>
                Friday 07 Juli 2023 ; 12:05
              </span>
            </div>
            <div className='tw-flex tw-justify-between tw-text-left'>
              <span>{t('product.complete_payment2')}</span>
              <span className='tw-text-dark-green tw-font-semibold'>
                Sunday 09 Juli 2023 ; 12:05
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='tw-bg-white tw-p-4 tw-w-full tw-rounded-lg tw-border tw-border-light-green tw-mb-5'>
        <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-3xl tw-text-xl tw-mt-5 tw-mb-8 tw-text-center'>
          How to make payment
        </h1>
        <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['1', '2']}>
          {items.map((item) => {
            return (
              <AccordionItem key={item.uuid} uuid={item.uuid} className='tw-p-3 tw-mb-4'>
                <AccordionItemHeading className='tw-mb-0'>
                  <AccordionItemButton className='tw-flex tw-justify-between tw-items-center tw-pb-3 tw-border-b tw-border-gray-700'>
                    <h2 className='tw-text-dark-green tw-text-lg tw-font-semibold'>
                      {item.heading}
                    </h2>
                    <div>
                      <AccordionItemState>
                        {({ expanded }) => (
                          <BiChevronDown
                            className={`${
                              expanded ? 'tw-rotate-[180deg]' : 'tw-rotate-[0deg]'
                            } tw-text-dark-green tw-text-4xl`}
                          />
                        )}
                      </AccordionItemState>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className='tw-mt-2'>
                  <div className='tw-flex tw-flex-col tw-gap-5'>
                    <div className='tw-bg-white tw-p-4 tw-w-full tw-rounded-lg '>
                      <div className='tw-flex tw-flex-col tw-relative tw-gap-3'>
                        <ul className='tw-mt-2 tw-list-decimal'>
                          {item.data.map((data, index) => {
                            return <li key={`li-item-${index}`}>{data}</li>;
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>

      <div className='tw-flex tw-flex-1 tw-justify-center md:tw-flex-row tw-flex-col tw-mt-10 tw-gap-5'>
        <StyledButton
          title='Refresh page'
          className='btn-dark-to-light-green-gradient tw-text-white tw-font-semibold md:tw-text-xl tw-text-md tw-items-center md:tw-px-12 tw-px-3 tw-py-2 tw-rounded-full md:tw-flex'
          onClick={() => console.log('WKWKKW')}
        />
      </div>
    </div>
  );
};


export default PendingPaymentStatus
